import React from 'react';
import ConfigPanel, { ConfigProps } from '@components/config/ConfigPanel';
import { DataCollectorConfigPanel } from '@components/config/DataCollectorConfigPanel';

interface Props {
    onError: (error: Error) => void;
    configuration: ConfigProps;
    onConfigChange: (config: ConfigProps) => void;
}

const Collector: React.FC<Props> = ({ onError, onConfigChange, configuration }) => {
    return (
        <ConfigPanel twoSidesPanelDataQa="collector-two-sides-panel">
            <DataCollectorConfigPanel
                config={configuration}
                onConfigChange={onConfigChange}
                onError={onError}
            />
        </ConfigPanel>
    );
};

export default Collector;
